import {inject, Injectable} from '@angular/core';
import {Route, Router} from '@angular/router';
import {SidebarMenuItem, SidebarSection} from '../model/sidebar.model';

interface SidebarRouteData {
  icon: string;
  label: string;
}

@Injectable({providedIn: 'root'})
export class SidebarService {
  private readonly router = inject(Router);

  getSidebarSections(): SidebarSection[] {
    return this.router.config
      .filter(route => this.hasSidebarData(route))
      .map(route => this.mapRouteToSection(route));
  }

  private hasSidebarData(route: Route): boolean {
    return !!route.data?.['sidebar'];
  }

  private mapRouteToSection(route: Route): SidebarSection {
    const sidebarData = route.data!['sidebar'] as SidebarRouteData;

    return {
      route: `/${route.path}`,
      label: sidebarData.label,
      icon: sidebarData.icon,
      children: this.mapChildren(route)
    };
  }

  private mapChildren(route: Route): SidebarMenuItem[] {
    if (!route.children) return [];

    return route.children
      .filter(child => this.hasSidebarData(child))
      .map(child => this.mapChildToMenuItem(route.path!, child));
  }

  private mapChildToMenuItem(parentPath: string, child: Route): SidebarMenuItem {
    const sidebarData = child.data!['sidebar'] as SidebarRouteData;

    return {
      route: `/${parentPath}/${child.path}`,
      label: sidebarData.label,
      icon: sidebarData.icon
    };
  }
}
